import {
  FETCH_RFQ_NOTIFICATION_RULES_REQUEST,
  FETCH_RFQ_NOTIFICATION_RULES_SUCCESS,
  FETCH_RFQ_NOTIFICATION_RULES_FAILURE,
  FETCH_RFQ_NOTIFICATION_RULE_DETAILS_REQUEST,
  FETCH_RFQ_NOTIFICATION_RULE_DETAILS_SUCCESS,
  FETCH_RFQ_NOTIFICATION_RULE_DETAILS_FAILURE,
  CREATE_RFQ_NOTIFICATION_RULE_REQUEST,
  CREATE_RFQ_NOTIFICATION_RULE_SUCCESS,
  CREATE_RFQ_NOTIFICATION_RULE_FAILURE,
  UPDATE_RFQ_NOTIFICATION_RULE_REQUEST,
  UPDATE_RFQ_NOTIFICATION_RULE_SUCCESS,
  UPDATE_RFQ_NOTIFICATION_RULE_FAILURE,
  // DELETE_RFQ_NOTIFICATION_RULE_REQUEST/SUCCESS/FAILURE are intentionally
  // not imported — see the comment above the switch (AC-11): this reducer
  // no longer has cases for them.
  FETCH_CONTACTS_WITH_STATS_REQUEST,
  FETCH_CONTACTS_WITH_STATS_SUCCESS,
  FETCH_CONTACTS_WITH_STATS_FAILURE,
  FETCH_CONTACTS_WITH_STATS_CANCELLED,
  TEST_RFQ_NOTIFICATION_RULE_REQUEST,
  TEST_RFQ_NOTIFICATION_RULE_SUCCESS,
  TEST_RFQ_NOTIFICATION_RULE_FAILURE,
  FETCH_RFQ_SOURCES_REQUEST,
  FETCH_RFQ_SOURCES_SUCCESS,
  FETCH_RFQ_SOURCES_FAILURE,
  CLEAR_RFQ_NOTIFICATIONS_ERROR,
  CLEAR_CURRENT_RULE
} from '../actions/types';

const initialState = {
  rules: [],
  count: 0,
  offset: 0,
  limit: 20,
  loading: false,
  error: null,
  currentRule: null,
  ruleDetailsLoading: false,
  ruleDetailsError: null,
  contacts: [],
  contactsLoading: false,
  contactsError: null,
  testResults: null,
  testLoading: false,
  testError: null,
  rfqSources: [],
  rfqSourcesLoading: false,
  rfqSourcesError: null
};

function rfqNotificationsReducer(state = initialState, action) {
  const { type, payload } = action;
  
  switch (type) {
    case FETCH_RFQ_NOTIFICATION_RULES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_RFQ_NOTIFICATION_RULES_SUCCESS:
      return {
        ...state,
        loading: false,
        rules: payload.rules,
        count: payload.count,
        offset: payload.offset,
        limit: payload.limit,
        error: null
      };
    case FETCH_RFQ_NOTIFICATION_RULES_FAILURE:
      return {
        ...state,
        loading: false,
        error: payload
      };
    
    case CREATE_RFQ_NOTIFICATION_RULE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case CREATE_RFQ_NOTIFICATION_RULE_SUCCESS:
      // List is re-fetched after the mutation; local array is not mutated.
      return {
        ...state,
        loading: false,
        error: null
      };
    case CREATE_RFQ_NOTIFICATION_RULE_FAILURE:
      return {
        ...state,
        loading: false,
        error: payload
      };
    
    case UPDATE_RFQ_NOTIFICATION_RULE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case UPDATE_RFQ_NOTIFICATION_RULE_SUCCESS:
      // List is re-fetched after the mutation; local array is not mutated.
      return {
        ...state,
        loading: false,
        error: null
      };
    case UPDATE_RFQ_NOTIFICATION_RULE_FAILURE:
      return {
        ...state,
        loading: false,
        error: payload
      };
    
    // DELETE_RFQ_NOTIFICATION_RULE_REQUEST/SUCCESS/FAILURE intentionally have
    // no cases here (AC-11): deletion progress and its failure message live
    // in RulesList local state so the shared list `loading`/`error` fields —
    // and the list-area banner they feed — stay untouched by a delete
    // attempt. The list itself is refreshed via a separate re-fetch on
    // success (ManageRules.handleDeleteRule); the default case below is a
    // no-op for these action types.

    case FETCH_CONTACTS_WITH_STATS_REQUEST:
      return {
        ...state,
        contactsLoading: true,
        contactsError: null
      };
    case FETCH_CONTACTS_WITH_STATS_SUCCESS:
      return {
        ...state,
        contactsLoading: false,
        contacts: payload,
        contactsError: null
      };
    case FETCH_CONTACTS_WITH_STATS_FAILURE:
      return {
        ...state,
        contactsLoading: false,
        contactsError: payload
      };
    case FETCH_CONTACTS_WITH_STATS_CANCELLED:
      // Request aborted by component unmount or a newer request:
      // clear loading but preserve existing contacts and error state.
      return {
        ...state,
        contactsLoading: false
      };
    
    case TEST_RFQ_NOTIFICATION_RULE_REQUEST:
      return {
        ...state,
        testLoading: true,
        testError: null
      };
    case TEST_RFQ_NOTIFICATION_RULE_SUCCESS:
      return {
        ...state,
        testLoading: false,
        testResults: payload,
        testError: null
      };
    case TEST_RFQ_NOTIFICATION_RULE_FAILURE:
      return {
        ...state,
        testLoading: false,
        testError: payload
      };
    
    case FETCH_RFQ_NOTIFICATION_RULE_DETAILS_REQUEST:
      return {
        ...state,
        ruleDetailsLoading: true,
        ruleDetailsError: null
      };
    case FETCH_RFQ_NOTIFICATION_RULE_DETAILS_SUCCESS:
      return {
        ...state,
        ruleDetailsLoading: false,
        currentRule: payload,
        ruleDetailsError: null
      };
    case FETCH_RFQ_NOTIFICATION_RULE_DETAILS_FAILURE:
      return {
        ...state,
        ruleDetailsLoading: false,
        ruleDetailsError: payload
      };
    
    case FETCH_RFQ_SOURCES_REQUEST:
      return {
        ...state,
        rfqSourcesLoading: true,
        rfqSourcesError: null
      };
    case FETCH_RFQ_SOURCES_SUCCESS:
      return {
        ...state,
        rfqSourcesLoading: false,
        rfqSources: payload,
        rfqSourcesError: null
      };
    case FETCH_RFQ_SOURCES_FAILURE:
      return {
        ...state,
        rfqSourcesLoading: false,
        rfqSourcesError: payload
      };
    
    case CLEAR_RFQ_NOTIFICATIONS_ERROR:
      return {
        ...state,
        error: null,
        contactsError: null,
        testError: null,
        ruleDetailsError: null,
        rfqSourcesError: null
      };
    
    case CLEAR_CURRENT_RULE:
      return {
        ...state,
        currentRule: null,
        ruleDetailsLoading: false,
        ruleDetailsError: null
      };
    
    default:
      return state;
  }
}

export default rfqNotificationsReducer;